var render, staticRenderFns
var script = {}
import style0 from "./GlobalStyling.vue?vue&type=style&index=0&id=7b194678&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports